import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(4),
  },
  notFoundLabel: {
    color: theme.palette.error.dark,
  },
}));

export default useStyles;
